import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { makeStyles } from '@material-ui/core/styles';
import colors from '../../foundations/colors.module.scss';
import typography from '../../foundations/typography.module.scss';
export const standardColor = colors.dark700;
export const disabledColor = colors.dark300;
export const focusedColor = colors.purple800;
export const inlineSelectStandardColor = colors.dark900;
export const inlineSelectPrimaryColor = colors.purple800;
export const inlineSelectErrorColor = colors.red950;
export const inlineSelectDisabledColor = colors.dark500;
export const baseFont = {
    fontFamily: typography.fontFamilyNormal,
    fontSize: typography.fontSizeP1
};
export const useInlineSelectDatePickerStyles = makeStyles({
    root: {
        width: undefined,
        marginRight: '-20px',
        display: 'inline-block',
        position: 'relative',
        paddingRight: '8px'
    },
    helperText: {
        fontSize: 12,
        marginTop: 0,
        marginLeft: 0,
        marginRight: 0,
        '&.positionFixed': {
            position: 'absolute',
            bottom: 0,
            left: 0,
            transform: 'translateY(100%)'
        },
        width: '100%',
        lineHeight: 'normal'
    },
    label: {
        fontFamily: typography.fontFamilyLight,
        color: standardColor,
        fontSize: typography.fontSizeP1,
        '&.Mui-disabled': {
            color: disabledColor
        },
        '&.Mui-focused': {
            color: focusedColor
        }
    },
    input: (param)=>{
        let { inlineSelectColor } = param;
        return _object_spread_props(_object_spread({}, baseFont), {
            color: inlineSelectColor,
            '&.Mui-error': {
                color: inlineSelectErrorColor,
                '& .MuiInputAdornment-root svg path[fill="#6942F8"]': {
                    fill: "".concat(inlineSelectErrorColor, " !important")
                },
                '& .MuiInputAdornment-root svg path[fill="#C3B3FC"]': {
                    fill: "".concat(inlineSelectErrorColor, " !important"),
                    opacity: 0.5
                }
            },
            '&.Mui-disabled': {
                color: inlineSelectDisabledColor,
                '& .MuiInputAdornment-root svg': {
                    opacity: 0.4
                }
            },
            '& .MuiInputAdornment-root': {
                marginLeft: '-36px',
                marginTop: '-2px',
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '& .MuiIconButton-root': {
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                '& svg': {
                    width: '16px',
                    height: '16px',
                    display: 'block',
                    '& path[fill="#6942F8"]': {
                        fill: "".concat(inlineSelectColor, " !important")
                    },
                    '& path[fill="#C3B3FC"]': {
                        fill: "".concat(inlineSelectColor, " !important"),
                        opacity: 0.5
                    }
                }
            },
            '&.MuiInput-underline': {
                '&&&:before': {
                    border: 'none',
                    right: 'auto',
                    left: 0,
                    width: 'calc(100% - 36px)',
                    bottom: '4px'
                },
                '&&&:hover:before': {
                    borderBottom: '1px solid',
                    borderBottomColor: inlineSelectColor,
                    bottom: '4px',
                    right: 'auto',
                    left: 0,
                    width: 'calc(100% - 36px)'
                },
                '&&&.Mui-error:hover:before': {
                    borderBottom: '1px solid',
                    borderBottomColor: inlineSelectErrorColor,
                    bottom: '4px',
                    right: 'auto',
                    left: 0,
                    width: 'calc(100% - 36px)'
                },
                '&&:after': {
                    border: 'none',
                    right: 'auto',
                    left: 0,
                    width: 'calc(100% - 36px)',
                    bottom: '4px'
                }
            }
        });
    },
    inputInput: (param)=>{
        let { isDisabled, isMobileDevice } = param;
        return _object_spread_props(_object_spread({}, baseFont), {
            padding: 0,
            lineHeight: '24px',
            height: isMobileDevice ? 16 : 22,
            cursor: isDisabled ? 'default' : 'pointer'
        });
    },
    inputInput_medium: {
        height: 38
    },
    inputInput_small: {
        height: 32
    },
    adornedEnd: {
        paddingRight: 0
    }
});
